"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../../index");
// Internally we are using Tabs here so that we can reuse the index tracking logic for selection.
// But vertical nav doesn't mean to be vertical Tab.
// They have the similar menu section, but vertical nav doesn't come with content panel.
var VerticalNav = /** @class */ (function (_super) {
    __extends(VerticalNav, _super);
    function VerticalNav(props) {
        var _this = _super.call(this, props) || this;
        _this.isVerticalNav = true;
        _this.extraContainerClassName = "oui-react-vertical-nav";
        return _this;
    }
    return VerticalNav;
}(index_1.Tabs));
exports.default = VerticalNav;
//# sourceMappingURL=VerticalNav.js.map